module.exports = {
  ym_tracking_id: 74782303,
};
